export default __webpack_public_path__ + "static/media/fordata-red-black.f6215635.png";